/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Auth_TokenInputs */

const cs_import_auth_token = /** @type {(inputs: Import_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít IT token`)
};

const en_import_auth_token = /** @type {(inputs: Import_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use IT import token`)
};

/**
* | output |
* | --- |
* | "Use IT import token" |
*
* @param {Import_Auth_TokenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_auth_token = /** @type {((inputs?: Import_Auth_TokenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Auth_TokenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_auth_token(inputs)
	return cs_import_auth_token(inputs)
});